<div mat-dialog-title class="dialog-header">
  <button type="button" class="close-button" (click)="dialogRef.close()" aria-label="Close dialog">
    <mat-icon>close</mat-icon>
  </button>

  <h4 class="mt-0">Edit Title</h4>
</div>
<div mat-dialog-content class="dialog-content">
  <p> {{ dialogData.dialogMessage }} </p>
  <mat-form-field style="width: 100%" class="mb-2">
    <input matInput placeholder="Widget Title?" #widgetTitle [(ngModel)]="dialogData.title" style="width: 100%;">
  </mat-form-field>
</div>
<div mat-dialog-actions class="dialog-footer">
  <div class="buttons-wrap">
    <button class="mat-green" (click)="dialogRef.close(dialogData.title)" mat-raised-button>OK</button>
    <button class="mat-grey" (click)="dialogRef.close()" mat-raised-button>Cancel</button>
  </div>
</div>
